import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import Field from '@/packages/field';
import DictApi from '@/api/dict';
import { InfoComplementField } from '../../types';

import style from './index.module.scss';

@Component({ name: 'EducationDegree' })
export default class EducationDegree
  extends Vue
  implements InfoComplementField {
  @Prop()
  private value!: undefined | number;

  private educationDegree: undefined | number | null = null;

  private errorMsg = '';

  private created() {
    this.educationDegree = this.value;
  }

  @Watch('value')
  private onValueChange(val: undefined | number) {
    if (val !== this.educationDegree) {
      this.educationDegree = val;
    }
  }

  public onValidator(): boolean {
    if (this.educationDegree === undefined || this.educationDegree === null) {
      this.errorMsg = '请选择学历';
      return false;
    }

    return true;
  }

  private onChangeEducationDegree(val: number | undefined | null) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private render() {
    return (
      <div class={style.educationDegree}>
        <Field
          v-model={this.educationDegree}
          label="学历"
          sub={true}
          type="select"
          onChange={() => this.onChangeEducationDegree(this.educationDegree)}
          dictApi={DictApi.getEducationLevels}
          error={this.errorMsg}
          readonly={true}
        />
      </div>
    );
  }
}
